import { transformScale } from '@turf/turf'

export function applyBufferInGeoJSON(geojson: any, value: number) {
  const METERS = 4
  const buffer = 2 * value
  const scale = (METERS + buffer) / METERS

  return transformScale(geojson, scale)
}
